import { render, staticRenderFns } from "./C_App_NewVersionApp.vue?vue&type=template&id=6def73f9&scoped=true&"
import script from "./C_App_NewVersionApp.vue?vue&type=script&lang=js&"
export * from "./C_App_NewVersionApp.vue?vue&type=script&lang=js&"
import style0 from "./C_App_NewVersionApp.vue?vue&type=style&index=0&id=6def73f9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6def73f9",
  null
  
)

export default component.exports